function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var NativeDragSource =
/*#__PURE__*/
function () {
  function NativeDragSource(config) {
    var _this = this;

    _classCallCheck(this, NativeDragSource);

    this.config = config;
    this.item = {};
    Object.keys(this.config.exposeProperties).forEach(function (property) {
      Object.defineProperty(_this.item, property, {
        configurable: true,
        enumerable: true,
        get: function get() {
          // eslint-disable-next-line no-console
          console.warn("Browser doesn't allow reading \"".concat(property, "\" until the drop event."));
          return null;
        }
      });
    });
  }

  _createClass(NativeDragSource, [{
    key: "mutateItemByReadingDataTransfer",
    value: function mutateItemByReadingDataTransfer(dataTransfer) {
      var _this2 = this;

      var newProperties = {};

      if (dataTransfer) {
        Object.keys(this.config.exposeProperties).forEach(function (property) {
          newProperties[property] = {
            value: _this2.config.exposeProperties[property](dataTransfer, _this2.config.matchesTypes)
          };
        });
      }

      Object.defineProperties(this.item, newProperties);
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      return true;
    }
  }, {
    key: "beginDrag",
    value: function beginDrag() {
      return this.item;
    }
  }, {
    key: "isDragging",
    value: function isDragging(monitor, handle) {
      return handle === monitor.getSourceId();
    }
  }, {
    key: "endDrag",
    value: function endDrag() {// empty
    }
  }]);

  return NativeDragSource;
}();